<div class="container-fluid">
  <div class="row">
    <div class="col-md-6">
      <div class="card">
        <div class="card-body">
          <h4 class="card-title">{{cardTitle}}</h4>
          <div class="form-group">
            <label for="uid">Effective Date *</label>
            <div class="input-group">
              <input type="text" class="form-control" placeholder="yyyy/mm/dd" data-val="true"
                     ngbDatepicker #EffectiveDate="ngbDatepicker" required [(ngModel)]="PostData.EffectiveDate">
              <div class="input-group-append">
                <button class="btn" (click)="EffectiveDate.toggle()" type="button"><i class="fa fa-calendar"></i></button>
              </div>
            </div>
          </div>
          <div class="form-group">
            <label for="uid">Expired Date *</label>
            <div class="input-group">
              <input type="text" class="form-control" placeholder="yyyy/mm/dd" data-val="true"
                     ngbDatepicker #ExpiredDate="ngbDatepicker" required [(ngModel)]="PostData.ExpiredDate">
              <div class="input-group-append">
                <button class="btn" (click)="ExpiredDate.toggle()" type="button"><i class="fa fa-calendar"></i></button>
              </div>
            </div>
          </div>

          <div class="form-group">
            <label>Subject *</label>
            <input type="text" class="required form-control" required [(ngModel)]="PostData.Subject" #Subject="ngModel" placeholder="">

          </div>
          <div class="form-group">
            <label>Content *</label>
            <textarea id="sqlScript" rows="5" class="required form-control" required [(ngModel)]="PostData.Contents"
            #Content="ngModel" placeholder=""></textarea>
          </div>
          <div class="form-group">
            <label>IsEnabled</label>
            <ng-select [searchable]="false" [items]="DropdownEnabled" id="Enabled" bindValue="value" bindLabel="text"
                       [clearable]="false" [(ngModel)]="PostData.IsEnabled">
            </ng-select>
          </div>

          <p>(*) Mandatory</p>
        </div>
        <div class="border-top">
          <div class="card-body">
            <button (click)="Cancel()" class="btn btn-outline-secondary m-1" role="button">Cancel</button>
            <button (click)="Submit()" class="btn btn-success m-1" role="button" [disabled]="isValid()">Submit</button>
          </div>
        </div>
      </div>
      <div>
      </div>
    </div>
